// extracted by mini-css-extract-plugin
module.exports = {"group":"ToggleGroup_group__4fjd8","option":"ToggleGroup_option__bgHl_","control":"ToggleGroup_control__703j9"};